import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

interface ListItem {
  id: string;
  title: string;
  subtitle?: string;
  icon?: string;
  badge?: string;
}

interface ListWidgetProps {
  title: string;
  items: ListItem[];
}

export default function ListWidget({ title, items }: ListWidgetProps) {
  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="flex-shrink-0">
        <CardTitle className="truncate">{title}</CardTitle>
      </CardHeader>
      <CardContent className="flex-1 p-0 overflow-auto">

        <div className="divide-y">
          {items && items.length > 0 ? (
            items.map((item) => (
              <div
                key={item.id}
                className="px-6 py-4 hover:bg-muted/50 transition-colors"
              >
                <div className="flex items-center gap-3">
                  {item.icon && <span className="text-2xl flex-shrink-0">{item.icon}</span>}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2">
                      <p className="font-medium truncate flex-1">{item.title}</p>
                      {item.badge && <Badge variant="secondary" className="flex-shrink-0">{item.badge}</Badge>}
                    </div>
                    {item.subtitle && (
                      <p className="text-sm text-muted-foreground mt-1 truncate">{item.subtitle}</p>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="px-6 py-8 text-center text-muted-foreground">
              Nenhum item na lista
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
